/* eslint-disable import/no-unused-modules */
// eslint-disable-next-line import/consistent-type-specifier-style
import type { introspection } from "generated/graphql-env.d.ts"
// eslint-disable-next-line import/consistent-type-specifier-style
import type { introspection as OEBackendIntrospection } from "generated/graphql-oe-backend-env"
import { type Prettify } from "@oefr/utils/types"
import { initGraphQLTada, type VariablesOf } from "gql.tada"

type Scalars = {
    Decimal: string
    ID: string
    String: string
    Boolean: boolean
    Int: number
    Float: number
    Date: string
    BigInt: number
    DateTime: string
    Time: string
    GenericScalar: unknown
    JSONString: string
    UUID: string
    Email: string
    RoleString: string
    NonEmptyString: string
}

export const OEBackend = {
    graphql: initGraphQLTada<{
        introspection: OEBackendIntrospection
        scalars: Scalars
    }>(),
}

export type OEBackendScalar<TScalar extends Readonly<string>> = ReturnType<
    typeof OEBackend.graphql.scalar<TScalar>
>

// TODO: Export kraken.graphql instead of graphql
export const graphql = initGraphQLTada<{
    introspection: introspection
    scalars: Scalars
}>()

export type InputOf<T> = Prettify<
    "input" extends keyof VariablesOf<T> ? VariablesOf<T>["input"] : never
>

export {
    type DocumentDecoration,
    type FragmentOf,
    maskFragments,
    readFragment,
    type ResultOf,
    type TadaDocumentNode,
    unsafe_readResult,
    type VariablesOf,
} from "gql.tada"

export type Scalar<TScalar extends Readonly<string>> = ReturnType<typeof graphql.scalar<TScalar>>
